import { useState } from "react";
import { Loader2, KeyRound, RefreshCw } from "lucide-react";
import { api, apiError } from "../../lib/api";
import { ErrorBox } from "./RegisterForm";

// 6-digit code entry. `onVerify(code)` does the real work (register or sign in) and throws on failure.
export const CodeStep = ({ email, devCode, onVerify, onResend }) => {
  const [code, setCode] = useState(devCode || "");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false); const [hint, setHint] = useState(devCode || "");
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await onVerify(code.replace(/\D/g, "")); } catch (ex) { setErr(apiError(ex)); setBusy(false); }
  };
  const resend = async () => {
    setErr("");
    try { const r = await onResend(); if (r?.dev_code) { setHint(r.dev_code); setCode(r.dev_code); } } catch (ex) { setErr(apiError(ex)); }
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="code-form">
      <p className="text-[12px] text-[#b4b9c1]">We emailed a 6-digit code to <span className="font-medium text-[#e8e9ec]" data-testid="code-email">{email}</span>. Enter it below — it expires in 10 minutes.</p>
      <input data-testid="code-input" autoFocus inputMode="numeric" pattern="[0-9 ]*" maxLength={7} value={code} onChange={(e) => setCode(e.target.value.replace(/[^\d]/g, "").slice(0, 6))}
        className="field h-12 text-center font-mono text-2xl tracking-[0.5em]" placeholder="••••••" />
      {hint && <p className="text-center text-[11px] text-[#f5c542]" data-testid="dev-code-hint">Email delivery isn't configured yet — your code is <span className="font-mono">{hint}</span></p>}
      <ErrorBox id="code-error" msg={err} />
      <button data-testid="code-submit" disabled={busy || code.length < 6} className="btn-red w-full py-2.5">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Verify</button>
      <button type="button" data-testid="code-resend" onClick={resend} className="flex w-full items-center justify-center gap-1 text-[11px] text-[#9aa0a8] hover:text-[#e8e9ec]"><RefreshCw className="h-3 w-3" /> Didn't get it? Send a new code</button>
    </form>
  );
};
